import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { observer } from 'mobx-react';
import React from 'react';

import { useI18n } from '../../../../../application/language/useI18n';
import { IApplicationsWithUnits } from '../store/IGroupedUnit';
import { Colors } from '../../../../design/color/Colors';

export interface ISystemsList {
  systems: IApplicationsWithUnits[];
}

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: '180px',
    gap: '32px',
  },
  systemCard: {
    flexShrink: 0,
    width: '368px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    borderRadius: '16px',
    border: '1px solid',
    borderColor: Colors.border,
    padding: '16px',
  },
  nameMb: { marginBottom: '8px' },
  dashContainer: { display: 'flex', gap: '2px', width: '100%' },
  dashPassed: {
    width: '100%',
    height: '4px',
    backgroundColor: Colors.chartSuccess,
    marginRight: '2px',
    '&:last-child': { marginRight: 0 },
  },
  dashNotPassed: {
    width: '100%',
    height: '4px',
    backgroundColor: Colors.bgSurface,
    marginRight: '2px',
    '&:last-child': { marginRight: 0 },
  },
}));

export const SystemsList = observer(({ systems }: ISystemsList) => {
  const i18n = useI18n();
  const classes = useStyles();

  if (systems.length === 0) {
    return <Typography variant="body1">{i18n.translate('systemList.noSystems')}</Typography>;
  }

  return (
    <Box className={classes.container}>
      {systems.map((system) => {
        const passedCount = system.unitResults.filter((result) => result?.isPassed).length;

        if (system.units.length === 0 || system.unitResults.length === 0) {
          return null;
        }
        return (
          <Box className={classes.systemCard} key={system.id}>
            <Typography variant="h6" className={classes.nameMb}>
              {system.name}
            </Typography>
            <Box className={classes.dashContainer}>
              {system.units.map((_, index) => (
                <Box key={index} className={index < passedCount ? classes.dashPassed : classes.dashNotPassed} />
              ))}
            </Box>
            <Typography variant="body2">
              {i18n.translate('systemList.finished')} {passedCount}/{system.units.length}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
});
